import { DateModel } from "../datemodel";
import { MenuModel } from "./menu.model";

export class MenuOrderModel {
    public dateData: DateModel;
    public menus: Array<MenuModel>;
}